<template>
  <div class="card">
    <h2>환영합니다 👋</h2>
    <p>
      아래 시작 메뉴(⊞ 시작)에서 <b>실거래가</b>를 눌러 조회 화면으로
      이동하세요.
    </p>
  </div>
</template>

<style scoped>
.card {
  max-width: 720px;
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .card {
    max-width: 100%;
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .card {
    padding: 10px;
    border-radius: 10px;
  }
}
</style>
